"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/heading/heading-context.tsx
var _react = require('react');
var HeadingContext = _react.createContext.call(void 0, 0);



exports.HeadingContext = HeadingContext;
